import { apiGet, apiPost, apiPut, apiDelete } from './api';
import type { VocabularyGroup } from '../types/vocabulary.types';

export const vocabularyGroupService = {
  /**
   * Fetch all vocabulary groups for the current user.
   */
  async getGroups(): Promise<VocabularyGroup[]> {
    return apiGet<VocabularyGroup[]>('/vocabulary-groups');
  },

  /**
   * Get a single vocabulary group by ID.
   */
  async getGroup(id: string): Promise<VocabularyGroup> {
    return apiGet<VocabularyGroup>(`/vocabulary-groups/${id}`);
  },

  /**
   * Create a new vocabulary group.
   */
  async createGroup(name: string): Promise<VocabularyGroup> {
    return apiPost<VocabularyGroup, { name: string }>('/vocabulary-groups', { name });
  },

  /**
   * Rename an existing vocabulary group.
   */
  async updateGroup(id: string, name: string): Promise<VocabularyGroup> {
    return apiPut<VocabularyGroup, { name: string }>(`/vocabulary-groups/${id}`, { name });
  },

  /**
   * Delete a vocabulary group.
   */
  async deleteGroup(id: string): Promise<{ id: string }> {
    return apiDelete<{ id: string }>(`/vocabulary-groups/${id}`);
  },
};
